import RootState from 'ducks/RootState';

export const getRestrictionsState = (state: RootState) => state.restrictions;

export const getRestrictionsGeoCollection = (state: RootState) => getRestrictionsState(state).geoCollection;
